import React from 'react';
import { Icon } from './Icon.js';
export const IconSortUpFill12 = ({ ...props }) => {
    return (React.createElement(Icon, { size: "12px", ...props },
        React.createElement("path", { d: "m9,3.5L7,.833c-.476-.636-1.524-.635-2,0l-2,2.667c-.286.381-.331.883-.118,1.309.213.426.641.691,1.118.691h4c.477,0,.905-.265,1.118-.691.213-.426.168-.927-.118-1.309Z", strokeWidth: "0", fill: "currentColor" })));
};
//# sourceMappingURL=IconSortUpFill12.js.map